export enum AllocationsMadeInValue {
    Face = 1,
    Fair = 2,
}